input OnfidoCallbackInput {
  check_types: [String!]
}
